import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UserFormData } from '../../shared/models/user.model';
import { NotificationService } from '../../shared/services/notification.service';
import { UsersService } from '../../shared/services/users.service';
import { UsersFormComponent } from '../users-form/users-form.component';

@Component({
  standalone: false,
  selector: 'app-users-update',
  templateUrl: 'users-update.component.html',
})
export class UsersUpdateComponent implements OnInit {
  @ViewChild(UsersFormComponent, { static: false }) form: UsersFormComponent;

  loading = false;

  constructor(
    public userService: UsersService,
    public router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Update user');
  }

  afterSave(action: void | boolean | 'reload' = false) {
    if (action === 'reload') {
      this.loadUser();
    } else if (action === true) {
      this.router.navigate(['/users']).then();
    }
  }

  ngOnInit() {
    this.loadUser();
  }

  private loadUser(): void {
    const userId = parseInt(this.route.snapshot.params['id']);
    this.loading = true;

    this.userService.one(userId).subscribe({
      next: model => {
        model.id = userId;
        if (model.parent) {
          this.userService.one(model.parent.id).subscribe({
            next: (parentModel: UserFormData) => {
              this.form.setModel(model, parentModel);
              this.loading = false;
            },
            error: e => this.handleLoadError(e),
          });
        } else {
          this.form.setModel(model);
          this.loading = false;
        }
      },
      error: e => this.handleLoadError(e),
    });
  }

  private handleLoadError(error): void {
    this.loading = false;
    this.notificationService.error(error, 'Users');
  }
}
